import React, {Component} from "react"
import {logout} from "../../actions/auth";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";

class Logout extends Component {
    constructor(props) {
        super(props);
        this.props.logout();

    }

    render() {
        return <Redirect to="/"/>
    }
}
const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
  mapStateToProps,
  { logout }
)(Logout);